import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import AuthLayout from "@/components/AuthLayout";
import AccessGate from "@/components/AccessGate";
import AppShell from "@/components/AppShell";
import SetupPage from "@/pages/SetupPage";
import AuditLogPage from "@/pages/AuditLogPage";
import AccessPage from "@/pages/AccessPage";
import LedgerPage from "@/pages/LedgerPage";
import CashflowPage from "@/pages/CashflowPage";
import ForecastPage from "@/pages/ForecastPage";
import MiscAccountsPage from "@/pages/MiscAccountsPage";
import MemoNotesPage from "@/pages/MemoNotesPage";
import DirectorAccountsPage from "@/pages/DirectorAccountsPage";
import SettlementPage from "@/pages/SettlementPage";
import DataQualityPage from "@/pages/DataQualityPage";
import ImportExportPage from "@/pages/ImportExportPage";
import BankFeedPage from "@/pages/BankFeedPage";
import ProfitLossPage from "@/pages/ProfitLossPage";
import InvoicingPage from "@/pages/InvoicingPage";
import DashboardPage from "@/pages/DashboardPage";
import PlayfulCursor from "@/components/PlayfulCursor";
import { ThemeProvider, useTheme } from "@/lib/theme";
import { Toaster } from "@/components/ui/sonner";

const Protected = () => (
  <>
    <Show when="signed-in">
      <AccessGate>
        <AppShell>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/cashflow" element={<CashflowPage />} />
            <Route path="/ledger" element={<LedgerPage />} />
            <Route path="/forecast" element={<ForecastPage />} />
            <Route path="/bank-feed" element={<BankFeedPage />} />
            <Route path="/profit-loss" element={<ProfitLossPage />} />
            <Route path="/invoicing" element={<InvoicingPage />} />
            <Route path="/misc-accounts" element={<MiscAccountsPage />} />
            <Route path="/memo-notes" element={<MemoNotesPage />} />
            <Route path="/director-accounts" element={<DirectorAccountsPage />} />
            <Route path="/settlement" element={<SettlementPage />} />
            <Route path="/data-quality" element={<DataQualityPage />} />
            <Route path="/import-export" element={<ImportExportPage />} />
            <Route path="/setup" element={<SetupPage />} />
            <Route path="/audit-log" element={<AuditLogPage />} />
            <Route path="/access" element={<AccessPage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AppShell>
      </AccessGate>
    </Show>
    <Show when="signed-out">
      <Navigate to="/sign-in" replace />
    </Show>
  </>
);

const ThemedToaster = () => <Toaster theme={useTheme().theme} position="bottom-right" />;

function App() {
  return (
    <ThemeProvider>
    <div className="App">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Routes>
            <Route
              path="/sign-in/*"
              element={<AuthLayout><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthLayout>}
            />
            <Route
              path="/sign-up/*"
              element={<AuthLayout><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthLayout>}
            />
            <Route path="/*" element={<Protected />} />
          </Routes>
        </ClerkAuthProvider>
      </BrowserRouter>
      <ThemedToaster />
      <PlayfulCursor />
    </div>
    </ThemeProvider>
  );
}

export default App;
